import React from "react";
import FormText from "./form/formText.component";
import ContainerBox from "./common/containerBox.component";
import { useDispatch, useSelector } from "react-redux";
import { enterBranchName } from "../actions/index";
import { stateProps } from "../types";
import FormSingleInput from "./form/formSingleInput.component";

const BranchName: React.FC = () => {
  const dispatch = useDispatch();

  const brnchName = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.branchName
  );

  const onInputChange = (event: any) => {
    const { value } = event.target;
    dispatch(enterBranchName(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"16"} title={"Bank Branch"} />
        <FormSingleInput
          value={brnchName}
          onInputChange={onInputChange}
          placeholder={"Bank branch"}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default BranchName;
